export enum BcmOrderStatusType {
    None = '',
    Open = 'open',
    Processing = 'processing',
    Paused = 'paused',
    WaitingForMaterial = 'waiting_for_material',
    WaitingForCustomer = 'waiting_for_customer',
    WaitingForExternal = 'waiting_for_external',
    ReadyForBilling = 'ready_for_billing',
    Done = 'done',
    Cancelled = 'cancelled',
    Payed = 'payed',
}

export const bcmOrderStatusTranslationKeys: Record<BcmOrderStatusType, string> = {
    [BcmOrderStatusType.None]: 'types.orderStatusTypes.none',
    [BcmOrderStatusType.Open]: 'types.orderStatusTypes.open',
    [BcmOrderStatusType.Processing]: 'types.orderStatusTypes.processing',
    [BcmOrderStatusType.Paused]: 'types.orderStatusTypes.paused',
    [BcmOrderStatusType.WaitingForMaterial]: 'types.orderStatusTypes.waiting_for_material',
    [BcmOrderStatusType.WaitingForCustomer]: 'types.orderStatusTypes.waiting_for_customer',
    [BcmOrderStatusType.WaitingForExternal]: 'types.orderStatusTypes.waiting_for_external',
    [BcmOrderStatusType.ReadyForBilling]: 'types.orderStatusTypes.ready_for_billing',
    [BcmOrderStatusType.Cancelled]: 'types.orderStatusTypes.cancelled',
    [BcmOrderStatusType.Done]: 'types.orderStatusTypes.done',
    [BcmOrderStatusType.Payed]: 'types.orderStatusTypes.payed',
};

export enum BcmOrderTaskPositionStatusType {
    Open = 'open',
    InProgress = 'in_progress',
    WaitingExternal = 'waiting_external',
    WaitingMaterial = 'waiting_material',
    WaitingForCustomer = 'waiting_for_customer',
    Paused = 'paused',
    Done = 'done',
}

export const bcmOrderTaskPositionStatusTranslationKeys: Record<BcmOrderTaskPositionStatusType, string> = {
    [BcmOrderTaskPositionStatusType.Open]: 'types.orderTaskPositionStatusTypes.open',
    [BcmOrderTaskPositionStatusType.InProgress]: 'types.orderTaskPositionStatusTypes.in_progress',
    [BcmOrderTaskPositionStatusType.WaitingExternal]: 'types.orderTaskPositionStatusTypes.waiting_external',
    [BcmOrderTaskPositionStatusType.WaitingMaterial]: 'types.orderTaskPositionStatusTypes.waiting_material',
    [BcmOrderTaskPositionStatusType.WaitingForCustomer]: 'types.orderTaskPositionStatusTypes.waiting_for_customer',
    [BcmOrderTaskPositionStatusType.Paused]: 'types.orderTaskPositionStatusTypes.paused',
    [BcmOrderTaskPositionStatusType.Done]: 'types.orderTaskPositionStatusTypes.done',
};

export interface BcmOrderStatusDto {
    id: number;
    bcm_orders_id: number;
    orderStatus: BcmOrderStatusType;
    note: string;
    insertedOn: Date;
    insertedBy: string;
    lastUpdateOn: Date;
    lastUpdateBy: string;
}

export class BcmOrderStatus {
    id;
    // tslint:disable-next-line:variable-name
    bcm_orders_id;
    orderStatus: BcmOrderStatusType = BcmOrderStatusType.Open;
    note;
    readonly insertedOn;
    readonly insertedBy;
    readonly lastUpdateOn;
    readonly lastUpdateBy;

    constructor(bcmOrderStatusDto: BcmOrderStatusDto) {

        this.id = bcmOrderStatusDto.id;
        this.bcm_orders_id = bcmOrderStatusDto.bcm_orders_id;
        this.orderStatus = bcmOrderStatusDto.orderStatus || BcmOrderStatusType.Open;
        this.note = bcmOrderStatusDto.note;
        this.insertedOn = bcmOrderStatusDto.insertedOn;
        this.insertedBy = bcmOrderStatusDto.insertedBy;
        this.lastUpdateOn = bcmOrderStatusDto.lastUpdateOn;
        this.lastUpdateBy = bcmOrderStatusDto.lastUpdateBy;
    }
}
